







import { Vue, Component } from 'vue-property-decorator';

const DEVELOP_BRANCH = 'develop';

@Component
export default class App extends Vue {
  buildId = '';
  showBuildId = false;

  created() {
    this.buildId = [process.env.VUE_APP_BUILD_BRANCH, process.env.VUE_APP_BUILD_NUMBER].join(' ');
    this.showBuildId = process.env.VUE_APP_BUILD_BRANCH === DEVELOP_BRANCH;
  }
}
